<template>
    <!--    <form ref="form" @submit.prevent>-->
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">예약시간 설정</span>
            <span class="txt">
                센터의 수업시간 시작설정 및 회원예약 어플리케이션(App)에서 회원이 수업을 예약, 취소하는 시간을 설정할 수
                있습니다. 또한, 강사의 수업 예약시간 제한설정이 가능합니다.
            </span>
        </div>

        <div class="com-tab">
            <router-link :to="{ name: 'SettingReservationTime' }" class="on">수업시간</router-link>
            <router-link :to="{ name: 'SettingReservationApp' }">회원예약 앱</router-link>
            <router-link :to="{ name: 'SettingReservationTeacher' }">강사수업 예약</router-link>
        </div>

        <p class="sub-title small">
            센터에서 진행하는 개인, 듀엣, OT 의 수업시작시간과 수업시간의 단위에 대한 시간표현을 설정합니다.
        </p>

        <div class="com-table-wrap">
            <div class="com-card-input half-type full">
                <div class="left-box full">
                    <span class="top-title">센터 운영시간 설정</span>
                    <p class="info-txt">
                        설정한 '센터 운영시간' 내에서 스케줄예약이 가능합니다. 회원이 직접 예약하는 경우, [직원관리 >
                        근무시간] 메뉴에서 직원별로 상세 설정하면 우선적용 됩니다.
                        <span class="line red">
                            * 직원 근무시간을 별도로 설정하지 않은 경우는 센터 운영시간으로 기본 설정 됩니다.
                        </span>
                    </p>
                    <div class="week-table">
                        <table class="com-table">
                            <colgroup>
                                <col style="width: 100px" />
                                <col style="width: 645px" />
                                <col style="width: 160px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>요일</th>
                                    <th>시간설정</th>
                                    <th>휴무일</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, i) in ['월', '화', '수', '목', '금', '토', '일']" :key="d">
                                    <td>{{ d }}</td>
                                    <td>
                                        <div class="flex center">
                                            <time-select :time.sync="data[`week${i + 1}StartTime`]" />
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <time-select :time.sync="data[`week${i + 1}EndTime`]" />
                                            <div
                                                v-if="!(data[`week${i + 1}StartTime`] < data[`week${i + 1}EndTime`])"
                                                class="invalid-message"
                                            >
                                                시간설정을 바르게 선택해주세요.
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="com-check">
                                            <input
                                                :id="'check-week-' + i"
                                                v-model="data[`week${i + 1}Yn`]"
                                                name="check-week"
                                                type="checkbox"
                                            />
                                            <label :for="'check-week-' + i"></label>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <span class="top-title">수업 시작시간 단위 설정</span>
                    <div class="line">
                        <span class="tit">
                            수업 예약 시 , 수업의 시작시간을 몇 분 단위로 선택할 수 있는 지설정합니다.
                        </span>
                        <div class="input-cnt flex">
                            <div class="com-radio">
                                <input
                                    id="radio-1-1"
                                    v-model="data.timeUnitValue"
                                    :value="5"
                                    name="radio-1"
                                    required
                                    type="radio"
                                />
                                <label for="radio-1-1">5분</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-1-2"
                                    v-model="data.timeUnitValue"
                                    :value="30"
                                    name="radio-1"
                                    required
                                    type="radio"
                                />
                                <label for="radio-1-2">30분</label>
                            </div>
                            <div class="com-radio">
                                <input
                                    id="radio-1-3"
                                    v-model="data.timeUnitValue"
                                    :value="60"
                                    name="radio-1"
                                    required
                                    type="radio"
                                />
                                <label for="radio-1-3">1시간</label>
                            </div>
                            <div v-if="!(data.timeUnitValue > 0)" class="invalid-message">
                                시간 단위를 산택해주세요.
                            </div>
                        </div>
                    </div>
                    <span class="top-title">시간표현 설정</span>
                    <div class="line">
                        <span class="tit">
                            센터에서 진행되는 수업에 대해, 센터에서 진행되는 수업에 대해, 회원예약 어플리케이션에서
                            표시되는 시간단위를 설정합니다. 만약 수업이 매 시의 정각에 시작하고 60분 수업을 50분으로
                            표현할 경우,
                            <br />
                            회원예약 어플리케이션에서는 08:00 ~ 08:50으로 표시됩니다.
                        </span>
                        <div v-for="(item, index) in data.timeDisplay" :key="index" class="input-cnt time-cnt flex">
                            <select-form
                                :select-data="['선택', '30분', '1시간', '1시간 30분', '2시간']"
                                :select-value="['', '30', '60', '90', '120']"
                                :selected-value.sync="item.app"
                                class="w180"
                                @update:set="(v) => $forceUpdate()"
                            />
                            <span class="txt">수업은 회원예약 어플리케이션에</span>
                            <input :ref="`time${index}`" v-model="item.time" class="w60 center" required type="text" />
                            <span class="txt">분 으로 표현합니다.</span>
                            <button
                                v-if="data.timeDisplay.length > 1"
                                class="com-btn red"
                                type="button"
                                @click="
                                    (e) => {
                                        data.timeDisplay.splice(index, 1);
                                        $forceUpdate();
                                    }
                                "
                            >
                                - 삭제
                            </button>
                            <button
                                v-if="index == data.timeDisplay.length - 1 && data.timeDisplay.length < 4"
                                class="com-btn"
                                type="button"
                                @click="
                                    (e) => {
                                        data.timeDisplay.push({});
                                        $forceUpdate();
                                    }
                                "
                            >
                                + 추가
                            </button>
                            <div v-if="!(item.app > 0 && item.time > 0)" class="invalid-message">
                                시간표현을 바르게 입력해주세요.
                            </div>
                            <div
                                v-if="!(data.timeDisplay.filter((o) => o.app == item.app).length == 1)"
                                class="invalid-message"
                            >
                                시간표현이 중복으로 선택되었습니다.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="bottom-btn">
            <button class="com-btn blue" type="submit" @click="save">저장</button>
        </div>
    </div>
    <!--    </form>-->
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'SettingReservationTime',
    components: { LoadingSpinner },
    props: {},
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            isLoading: false,
            data: {},
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            // 스웨거 검색: 센터예약시간설정 조회
            api.get(`/admin/api/center/${this.centerId}/reservation-setting`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data || {};
                    _.range(1, 8).forEach((i) => {
                        this.data[`week${i}StartTime`] = (this.data[`week${i}StartTime`] || '06:00').replace('+00', '');
                        this.data[`week${i}EndTime`] = (this.data[`week${i}EndTime`] || '23:00').replace('+00', '');
                    });
                    this.data.timeDisplay = [];
                    _.range(30, 121, 30).forEach((e, i) => {
                        if (!this.data[`timeDisplayApp${e}`]) return;
                        this.data.timeDisplay.push({
                            app: String(e),
                            time: String(this.data[`timeDisplayApp${e}`]),
                        });
                        this.data[`timeDisplayApp${e}`] = 0;
                    });
                    if (this.data.timeDisplay.length == 0) {
                        this.data.timeDisplay.push({ app: '', time: '' });
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    if (res.response.status != 404 || this.prodNo) {
                        alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    }
                    console.error(res);
                });
        },
        save() {
            // this.$refs.form.classList.remove('was-validated');
            // if (!this.$refs.form.checkValidity() || this.isLoading) {
            //     this.$refs.form.classList.add('was-validated');
            //     return;
            // }

            this.$forceUpdate();

            const error = false;

            // if (document.querySelector('.invalid-message')) {
            //     this.$refs.form.classList.add('was-validated');
            //     this.$refs.form.classList.add('invalid');
            //     return;
            // }

            _.range(30, 121, 30).forEach((e, i) => {
                if (error) return;
                const o = this.data.timeDisplay.filter((o) => o.app == e);
                this.data[`timeDisplayApp${e}`] = o.length ? o[0].time : 0;
            });

            this.isLoading = true;
            api.post(`/admin/api/center/${this.centerId}/reservation-setting`, this.data)
                .then((res) => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                    this.load();
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.spinner-container {
    height: 242px;
}
</style>
